/**
 * NavigationLink3D's configuration warning (navigation_link_3d.cpp:494-502) for
 * a start and end position that are approximately equal. Such a link still
 * creates a zero-length NavigationServer3D link, and Godot only warns, so this
 * rule warns. An absent position is the doc/classes/NavigationLink3D.xml default.
 */
import { ruleRegistry } from '../../../linter/RuleRegistry.js';
import { matchVector3 } from '../../../linter/validators/vectorValidators.js';
import { isEqualApprox } from '../../../godot/math/math.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../linter/ruleArms.js';
const arms = {
    startEqualsEnd: groundedArm('navigationlink3d-start-position-equals-end-position', {
        kind: 'configuration-warning',
    }),
};
/**
 * navigation_link_3d.h:43-44 declares both fields with no initializer, and the constructor
 * (:274-285) never sets them, so an absent key equals `Vector3(0, 0, 0)`
 * (doc/classes/NavigationLink3D.xml:81,92). The comparison runs even on a bare node, as the
 * engine's does: filling absence with the class default authors nothing.
 */
const DEFAULT_POSITION = { x: 0, y: 0, z: 0 };
/** The `Vector3(x, y, z)` a property carries, its XML default when absent, or null when malformed. */
function readPosition(properties, key) {
    const raw = properties[key];
    if (raw === undefined)
        return DEFAULT_POSITION;
    return matchVector3(raw);
}
/** `Vector3::is_equal_approx` (core/math/vector3.cpp:141-143): each component by `isEqualApprox`. */
function vector3EqualApprox(a, b) {
    return isEqualApprox(a.x, b.x) && isEqualApprox(a.y, b.y) && isEqualApprox(a.z, b.z);
}
function checkNavigationLink3D(context) {
    const { node } = context;
    const properties = node.rawProperties;
    const start = readPosition(properties, 'start_position');
    const end = readPosition(properties, 'end_position');
    // A malformed literal is the format validator's finding, so this rule stays silent.
    if (start === null || end === null)
        return [];
    if (!vector3EqualApprox(start, end))
        return [];
    return [
        armDiagnostic(arms.startEqualsEnd, node, `NavigationLink3D '${node.name}' has 'start_position' and 'end_position' at the same point. Godot's own editor flags this: a link needs its two ends apart to route anything through.`),
    ];
}
const navigationLink3DPositionRule = {
    meta: {
        name: 'valid-navigationlink3d-positions',
        description: "Warns when a NavigationLink3D's start_position and end_position are the same point, which Godot's own editor also flags",
        category: 'validation',
        applicableNodeTypes: ['NavigationLink3D'],
        emits: armEmits(arms),
    },
    check: checkNavigationLink3D,
};
ruleRegistry.register(navigationLink3DPositionRule);
//# sourceMappingURL=linter.js.map